<template>
  <WebsiteCmsShell
    class="website-slide-page"
    :title="'Slide Banner ' + clinic_name"
    subtitle="Atur banner utama dan urutan informasi yang tampil di beranda website"
    action-label="Slide Baru"
    list-eyebrow="Banner website"
    list-title="Daftar slide"
    list-description="Kelola urutan, status tayang, dan gambar setiap slide."
    @action="$router.push('/website/slide/add')"
  >
    <template #list><Table purpose="master" /></template>
  </WebsiteCmsShell>
</template>

<script>
import WebsiteCmsShell from "@/component/websites/WebsiteCmsShell.vue";
import Form from "@/component/websites/SlideForm.vue";
import FormEdit from "@/component/websites/SlideFormEdit.vue";
import FormDetail from "@/component/websites/SlideFormDetail.vue";
import Table from "@/component/websites/SlideTable.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "website-slide",
  data() {
    return {
      form: {
        title: "",
        text_1: "",
        text_2: "",
        text_3: "",
        order: "",
        status: "",
        image: [],
      },
      FormEditActv: false,
      FormDetailActv: false,
      clinic_name : window.configuration == null ? "Medhop" :  window.configuration.clinic_name
    };
  },
  components: {
    WebsiteCmsShell,
    Table,
    Form,
    FormEdit,
    FormDetail,
  },
  methods:{
    resetFormOnNew(){
      // reset form on new (tambah data)
      var self = this;
      Object.keys(this.form).forEach(function (key, index) {
        if (key === "image") {
          self.form[key] = [];
        } else if(key === "_method"){
          self.form[key] = "post"
        } else {
          self.form[key] = "";
        }
      });
    },

    scrollToElement(options) {
      let el = this.$el.getElementsByClassName("website-cms-editor-anchor")[0];
      if (el) {
        el.scrollIntoView(options);
        // reset form on new (tambah data)
        this.resetFormOnNew()
      }
    },

    scrollToTop(options) {
      // window.scrollTo(0, 0);
       let el = this.$el;
      // el = el ?? this.$el.getElementsByClassName("table-setting")[0];
      if (el) {
        el.scrollIntoView(options);
        // reset form on new (tambah data)
        this.resetFormOnNew()
      }
    },

    btnAddOnClick(){
      this.FormEditActv = false
      this.FormDetailActv = false
      this.scrollToElement({ behavior: 'smooth' })
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Website", route: "" },
      { title: "CMS", route: "" },
      { title: "Slide", route: "" },
    ]);

    // Add Website Slide
    this.$root.$on("updateWebsiteSlide", () => {
      // reset form on new (tambah data)
      this.scrollToTop({ behavior: 'smooth' })
      this.resetFormOnNew()
    });

      // Cancel Add Website Slide
    this.$root.$on("cancelAddWebsiteSlide", () => {
      // reset form on new (tambah data)
      this.scrollToTop({ behavior: "smooth" });
      this.resetFormOnNew();
    });

    //  Edit Website Slide
    this.$root.$on("getWebsiteSlideById", (data) => {
      this.FormDetailActv = false
      this.FormEditActv = true
     this.scrollToElement({ behavior: 'smooth' })

      if(data.status == 0){
        data.status = false
      }else if(data.status == 1){
        data.status = true
      }

      if(data.button == 0){
        data.button = false
      }else if(data.button == 1){
        data.button = true
      }

     this.form = data
     this.form['_method'] = 'put'
    });

    // Cancel Edit
    this.$root.$on("cancelWebsiteSlideUpdate", () => {
      this.FormEditActv = false
      this.scrollToTop({ behavior: 'smooth' })
      this.resetFormOnNew()
    });

    // Detail Web Slide
    this.$root.$on("getWebsiteSlideByIdDetail", (data) => {
      this.FormDetailActv = true
      this.FormEditActv = false
     this.scrollToElement({ behavior: 'smooth' })

      if(data.status == 0){
        data.status = false
      }else if(data.status == 1){
        data.status = true
      }
      if(data.button == 0){
        data.button = false
      }else if(data.button == 1){
        data.button = true
      }
     this.form = data
    });
  },
};
</script>
